import { useState, useEffect } from "react";
import axios from "axios";
import SvgLogo from "./SvgLogo";
import { Box, VStack, Heading } from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";
import Tag from "./Tag"
function Brands() {

  const [brands, setNewBrands] = useState([{
    "altText": "visa",
    "imageUrl": "/brands/visa-black.svg"
  }]);

  useEffect(() => {
    getBrands();
  }, []);

  function getBrands() {
    axios({
      method: "GET",
      url: "/brands/",
    })
      .then((response) => {
        const data = response.data;
        setNewBrands(data);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
          console.log(error.response.status);
          console.log(error.response.headers);
        }
      });
  }

  return (
    <FullScreenSection
      alignContent="flex-start"
      justifyContent="center"
      alignItems="flex-start"
      width="100%"
      flexDirection="column"
      isDarkBackground={false}
      minHeight="40vh"
    >
      <VStack
      display="flex"
        alignContent="flex-start"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={6}
        m={8}
        width="100%"

      >
        <Tag>You’ll be in good company</Tag>
        <Heading>Trusted by leading brands</Heading>
        <Box
          display="grid"
          gridTemplateColumns="repeat(5,minmax(0,1fr))"
          gridGap={12}
          width="100%"
        >
          {brands &&
            brands.map((brand, index) => (
              <SvgLogo
                key={`${brand.id}-${index}`}
                id={brand.id}
                altText={brand.altText}
                imageUrl={brand.imageUrl}
              />
            ))}
        </Box>
      </VStack>
    </FullScreenSection>
  );
}

export default Brands;
